// 前端开关配置，勿修改!!!由client/index根据客户参数自动生成!!!

export default {
api:'/',
CDNtoken:''}



// WEBPACK FOOTER //
// ./src/settings.js